// extracted by mini-css-extract-plugin
module.exports = {"container":"b1ddd01198--container--lTqd_","crumb":"b1ddd01198--crumb--N_28L","arrow":"b1ddd01198--arrow--f6SOK"};